import React from "react";

function Doctor({ gender }) {
  return gender === "M" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#edebed"
        d="M418.627 367.345l-87.036-25.599H180.41l-87.036 25.599c-21.087 6.203-35.567 25.555-35.567 47.535v72.346c0 13.682 11.092 24.774 24.774 24.774H429.42c13.682 0 24.774-11.092 24.774-24.774V414.88c0-21.98-14.481-41.333-35.567-47.535z"
        data-original="#edebed"
      ></path>
      <path
        fill="#a5cdff"
        d="M297.29 512h-82.58l-16.516-165.161h115.612z"
        data-original="#a5cdff"
      ></path>
      <path
        fill="#8cb4eb"
        d="M198.194 346.839l2.472 24.72c13.609 15.204 33.324 24.829 55.335 24.829s41.726-9.625 55.335-24.829l2.472-24.72H198.194z"
        data-original="#8cb4eb"
      ></path>
      <path
        fill="#f7d291"
        d="M256 379.871c-31.926 0-57.807-25.881-57.807-57.806v-57.807h115.613v57.807c0 31.925-25.88 57.806-57.806 57.806z"
        data-original="#f7d291"
      ></path>
      <path
        fill="#f0c382"
        d="M198.194 299.198c17.35 9.267 37.023 14.609 57.806 14.609s40.457-5.342 57.806-14.609v-34.94H198.194v34.94z"
        data-original="#f0c382"
      ></path>
      <path
        fill="#ffe1a0"
        d="M367.484 156.903h-4.129v-82.58h-214.71v82.581h-4.129c-11.355 0-20.645 9.29-20.645 20.645s9.29 20.645 20.645 20.645h4.546c4.23 55.419 50.435 99.097 106.938 99.097s102.708-43.678 106.938-99.097h4.546c11.355 0 20.645-9.29 20.645-20.645s-9.29-20.646-20.645-20.646z"
        data-original="#ffe1a0"
      ></path>
      <path
        fill="#6e5a64"
        d="M206.452 182.395a8.256 8.256 0 01-8.258-8.258v-8.258c0-4.56 3.694-8.258 8.258-8.258s8.258 3.698 8.258 8.258v8.258a8.256 8.256 0 01-8.258 8.258zm99.096 0a8.256 8.256 0 01-8.258-8.258v-8.258a8.256 8.256 0 018.258-8.258 8.256 8.256 0 018.258 8.258v8.258a8.255 8.255 0 01-8.258 8.258z"
        data-original="#6e5a64"
      ></path>
      <path
        fill="#a06e50"
        d="M214.71 148.645h-16.516c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h16.516c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.258 8.258zm99.096 0H297.29c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h16.516c4.565 0 8.258 3.698 8.258 8.258s-3.693 8.258-8.258 8.258z"
        data-original="#a06e50"
      ></path>
      <path
        fill="#f7d291"
        d="M148.645 74.323v82.581h-3.404c-9.402 0-18.184 5.958-20.62 15.04-3.683 13.733 6.715 26.251 19.895 26.251h4.546c4.23 55.419 50.435 99.097 106.938 99.097 5.649 0 11.157-.55 16.568-1.391-51.454-7.942-90.891-52.286-90.891-105.964v-50.184c0-19.387 16.374-35.169 35.696-33.577 5.408.446 11.087.684 17.054.684 23.946 0 50.683-3.822 79.471-11.359 12.578-3.293 23.397-10.959 30.788-21.178H148.645z"
        data-original="#f7d291"
      ></path>
      <path
        fill="#a06e50"
        d="M188.903 41.29l1.032 33.032s-24.774 24.774-24.774 57.806v10.194c0 8.329-6.202 15.355-14.468 16.389l-18.565 2.321V90.839c.001-27.365 25.807-50.925 56.775-49.549z"
        data-original="#a06e50"
      ></path>
      <path
        fill="#dbd9dc"
        d="M354.938 387.97l-16.357-16.357 17.505-23.34c3.785-5.047 2.076-12.289-3.567-15.111l-38.712-19.356L256 512h49.548l52.483-104.966a16.516 16.516 0 00-3.093-19.064z"
        data-original="#dbd9dc"
      ></path>
      <path
        fill="#a5cdff"
        d="M412.903 458.323h-12.387v-12.387c0-4.565-3.694-8.258-8.258-8.258S384 441.371 384 445.935v12.387h-12.387c-4.565 0-8.258 3.694-8.258 8.258s3.694 8.258 8.258 8.258H384v12.387c0 4.565 3.694 8.258 8.258 8.258s8.258-3.694 8.258-8.258v-12.387h12.387c4.565 0 8.258-3.694 8.258-8.258s-3.694-8.257-8.258-8.257z"
        data-original="#a5cdff"
      ></path>
      <path
        fill="#cd916e"
        d="M323.096 16.516l-1.032 57.806s24.774 24.774 24.774 57.806v10.194c0 8.329 6.202 15.355 14.468 16.389l18.565 2.321V66.065c0-27.365-25.806-50.925-56.775-49.549z"
        data-original="#cd916e"
      ></path>
      <path
        fill="#e3aa75"
        d="M256 239.484c-12.395 0-23.823-3.976-30.573-10.637-3.25-3.21-3.282-8.435-.081-11.677 3.218-3.25 8.444-3.282 11.677-.081 2.75 2.71 9.363 5.879 18.976 5.879s16.226-3.169 18.976-5.879c3.234-3.202 8.46-3.169 11.677.081 3.202 3.242 3.169 8.468-.081 11.677-6.748 6.661-18.176 10.637-30.571 10.637z"
        data-original="#e3aa75"
      ></path>
      <path
        fill="#dbd9dc"
        d="M157.063 387.97l16.357-16.357-17.505-23.34c-3.785-5.047-2.076-12.289 3.567-15.111l38.712-19.356L256 512h-49.548l-52.483-104.966a16.515 16.515 0 013.094-19.064z"
        data-original="#dbd9dc"
      ></path>
      <path
        fill="#b67f5f"
        d="M272 0c-68.898 0-82.102 20.945-135.155 37.843-3.646 1.161-5.287 5.384-3.226 8.607 11.512 18.008 54.361 64.946 176.096 33.073 14.255-3.732 25.217-15.226 28.107-29.676 3.348-16.741-6.826-33.321-22.123-40.901C303.549 2.926 287.615 0 272 0z"
        data-original="#b67f5f"
      ></path>
      <path
        fill="#a5cdff"
        d="M173.419 512h-66.065a8.258 8.258 0 01-8.258-8.258V470.71a8.258 8.258 0 018.258-8.258h66.065a8.258 8.258 0 018.258 8.258v33.032a8.258 8.258 0 01-8.258 8.258z"
        data-original="#a5cdff"
      ></path>
      <path
        fill="#fff"
        d="M140.387 478.968a8.253 8.253 0 01-8.258-8.258v-24.774c0-4.565 3.694-8.258 8.258-8.258s8.258 3.694 8.258 8.258v24.774a8.253 8.253 0 01-8.258 8.258z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#8cb4eb"
        d="M173.419 495.484h-66.065a8.258 8.258 0 01-8.258-8.258v16.516a8.258 8.258 0 008.258 8.258h66.065a8.258 8.258 0 008.258-8.258v-16.516a8.258 8.258 0 01-8.258 8.258z"
        data-original="#8cb4eb"
      ></path>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#edebed"
        d="M412.878 384.72l-85.291-30.103H184.413L99.122 384.72c-19.81 6.992-33.057 25.716-33.057 46.724v55.782c0 13.682 11.092 24.774 24.774 24.774h330.323c13.682 0 24.774-11.092 24.774-24.774v-55.782c-.001-21.009-13.248-39.732-33.058-46.724z"
        data-original="#edebed"
      ></path>
      <path
        fill="#a5cdff"
        d="M214.71 355.1h82.58V512h-82.58z"
        data-original="#a5cdff"
      ></path>
      <path
        fill="#8cb4eb"
        d="M214.71 390.107c11.314 9.079 25.656 14.538 41.29 14.538s29.976-5.46 41.29-14.538v-35.01h-82.58v35.01z"
        data-original="#8cb4eb"
      ></path>
      <path
        fill="#64505a"
        d="M404.528 257.771c-4.09-10.342-8.142-26.779-8.142-51.32v-66.065C396.387 62.853 333.533 0 256 0c-77.534 0-140.387 62.853-140.387 140.387v66.065c0 24.54-4.051 40.978-8.142 51.32-3.424 8.659 1.266 18.43 10.087 21.414 19.659 6.649 52.854 16.651 88.893 22.23h99.097c36.039-5.579 69.234-15.581 88.892-22.23 8.823-2.984 13.513-12.756 10.088-21.415z"
        data-original="#64505a"
      ></path>
      <path
        fill="#f1c9a4"
        d="M256 388.129c-27.365 0-49.548-22.184-49.548-49.548v-57.806h99.097v57.806c-.001 27.364-22.184 49.548-49.549 49.548z"
        data-original="#e3aa75"
      ></path>
      <path
        fill="#f3d2b2"
        d="M206.452 311.649c15.189 6.66 31.929 10.415 49.548 10.415s34.359-3.755 49.548-10.415v-30.875h-99.097l.001 30.875z"
        data-original="#d29b6e"
      ></path>
      <path
        fill="#f3d2b2"
        d="M256 305.548c-59.291 0-107.355-48.064-107.355-107.355V74.323h214.71v123.871c0 59.29-48.065 107.354-107.355 107.354z"
        data-original="#f5b97d"
      ></path>
      <path
        fill="#f1c9a4"
        d="M218.6 108.497a7.708 7.708 0 014.837-1.675c1.22 0 3.05.279 4.834 1.611 22.25 16.606 67.368 44.428 135.084 59.277V74.323h-214.71v123.871c0 59.29 48.065 107.355 107.355 107.355 5.632 0 11.118-.565 16.516-1.399-51.428-7.964-90.839-52.296-90.839-105.956v-46.549c0-11.33 5.848-21.778 15.397-27.876 7.389-4.719 14.661-9.813 21.526-15.272z"
        data-original="#e3aa75"
      ></path>
      <path
        fill="#6e5a64"
        d="M214.71 165.161h-16.516c-4.565 0-8.258-3.694-8.258-8.258s3.694-8.258 8.258-8.258h16.516c4.565 0 8.258 3.694 8.258 8.258s-3.694 8.258-8.258 8.258zm99.096 0H297.29c-4.565 0-8.258-3.694-8.258-8.258s3.694-8.258 8.258-8.258h16.516c4.565 0 8.258 3.694 8.258 8.258s-3.693 8.258-8.258 8.258z"
        data-original="#6e5a64"
      ></path>
      <path
        fill="#a5cdff"
        d="M404.645 458.323h-12.387v-12.387c0-4.565-3.694-8.258-8.258-8.258s-8.258 3.694-8.258 8.258v12.387h-12.387c-4.565 0-8.258 3.694-8.258 8.258s3.694 8.258 8.258 8.258h12.387v12.387c0 4.565 3.694 8.258 8.258 8.258s8.258-3.694 8.258-8.258v-12.387h12.387c4.565 0 8.258-3.694 8.258-8.258s-3.693-8.258-8.258-8.258zM181.677 512h-66.065a8.258 8.258 0 01-8.258-8.258V470.71a8.258 8.258 0 018.258-8.258h66.065a8.258 8.258 0 018.258 8.258v33.032a8.258 8.258 0 01-8.258 8.258z"
        data-original="#a5cdff"
      ></path>
      <path
        fill="#fff"
        d="M148.645 478.968a8.253 8.253 0 01-8.258-8.258v-24.774c0-4.565 3.694-8.258 8.258-8.258s8.258 3.694 8.258 8.258v24.774a8.253 8.253 0 01-8.258 8.258z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#64505a"
        d="M206.452 198.194a8.253 8.253 0 01-8.258-8.258v-8.258c0-4.565 3.694-8.258 8.258-8.258s8.258 3.694 8.258 8.258v8.258a8.254 8.254 0 01-8.258 8.258zm99.096 0a8.253 8.253 0 01-8.258-8.258v-8.258a8.253 8.253 0 018.258-8.258 8.253 8.253 0 018.258 8.258v8.258a8.253 8.253 0 01-8.258 8.258z"
        data-original="#64505a"
      ></path>
      <path
        fill="#fff"
        d="M227.562 227.067c-5.049 0-8.732 4.986-7.076 9.755 4.681 13.482 18.811 23.277 35.514 23.277s30.833-9.795 35.514-23.277c1.656-4.77-2.027-9.755-7.076-9.755h-56.876z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#6e5a64"
        d="M238.15 95.196c24.086 17.978 76.832 50.078 158.236 61.707v-12.838c0-78.689-64.393-145.515-143.069-144.041-76.296 1.429-137.705 63.724-137.705 140.362v5.269c17.614-6.639 60.175-24.214 92.707-50.086 8.681-6.901 20.943-7.007 29.831-.373z"
        data-original="#6e5a64"
      ></path>
      <path
        fill="#dbd9dc"
        d="M342.121 340.718l-36.573-17.25L256 512h41.29l45.675-98.963a16.515 16.515 0 00-1.254-16.083l-11.389-17.084 16.166-21.554c4.445-5.926 2.332-14.438-4.367-17.598zm-172.242 0l36.573-17.25L256 512h-41.29l-45.675-98.963a16.515 16.515 0 011.254-16.083l11.389-17.084-16.166-21.554c-4.445-5.926-2.332-14.438 4.367-17.598z"
        data-original="#dbd9dc"
      ></path>
      <path
        fill="#84737b"
        d="M396.217 133.975C392.863 57.094 328.574-1.385 253.318.025c-15.486.29-30.304 3.199-44.175 8.115 32.563 42.193 94.709 104.538 187.074 125.835z"
        data-original="#84737b"
      ></path>
      <path
        fill="#8cb4eb"
        d="M181.677 495.484h-66.065a8.258 8.258 0 01-8.258-8.258v16.516a8.258 8.258 0 008.258 8.258h66.065a8.258 8.258 0 008.258-8.258v-16.516a8.258 8.258 0 01-8.258 8.258z"
        data-original="#8cb4eb"
      ></path>
    </svg>
  );
}

export default Doctor;
